import { Indicator } from 'utils/models';
import { HeartRhythmMeasurementDiagnosis } from './heartRhythm/measurementDiagnosis';

export interface MeasurementContext {
  symptoms?: string[];
  symptomSeverity?: string;
  activity?: string;
}

type IndicatorProbability = {
  [key in Indicator]: number;
};

export interface MeasurementData {
  measurement_timestamp?: number;
  heartrate?: number;
  indicator?: Indicator;
  indicator_probability?: IndicatorProbability;
  diagnosis?: {
    text: string;
    label: HeartRhythmMeasurementDiagnosis[];
  };
  app?: {
    name?: string;
    version?: string;
    build?: number;
    fibricheck_sdk_version?: string;
    camera_sdk_version?: string;
  };
  device?: {
    os: string;
    model: string;
    manufacturer: string;
    type: string;
  };
  algorithm?: {
    version: string;
  };
  context?: MeasurementContext;
  viewResult?: boolean;
  fromBacklog?: boolean;
  claim?: {
    timestamp: string;
    userId: string;
  };
  tags?: string[];
  ppg?: PPG;
  peaks?: number[];
  flags?: Flag[];
  reviewRequestedTime?: number;
  reviewDuration?: number;
  reviewer_user_id?: string;
  reviewerName?: string;
  mostSevereLabel?: {
    color: string;
    key: string;
  };
}

export interface Flutter {
  [key: string]: FlutterData[];
}

export interface FlutterData {
  id: string;
  timestamp: number;
  heartrate: number;
}

export interface PPG {
  signal: number[];
  frequency: number;
}

export interface Flag {
  name: string;
  start: number[];
  end: number[];
}

export type GraphPoint = [number, number];
export type GraphPointRR = [number, boolean];
export interface GraphPointMax {
  x: number;
  y: number;
  tooltip: string;
  arrow: ArrowType;
  marker: ArrowMarker;
}

export type ArrowKey = 'right' | 'top' | 'corner';
export type ArrowType = 'single' | 'double';
export type ArrowMarker = 'bad' | 'good' | 'both';

export type Arrows = {
  [key in ArrowKey]: {
    [arrow in ArrowType]: {
      [marker in ArrowMarker]?: string;
    };
  };
};

export interface GraphPointFlutter {
  x: number;
  y: number;
  measurementId: string;
}
export interface GraphFlag {
  from: number;
  to: number;
  color: string;
}

export interface Point {
  x: number;
  y: number;
  t: number;
  z?: number;
}

export enum PatientDetailsDescriptionKeys {
  HeartRate = 'patientdetails_heartrhythmtab_tooltip',
  BloodPressure = 'patientdetails_bloodpressuretab_tooltip',
  WeightBmi = 'patientdetails_weightbmi_tooltip',
}

export interface ShouldDisplayMeasurementFusdrBadgeProps {
  measurementTags?: string[];
}

export interface MeasurementInformationBadge {
  color: string;
  label?: string;
  hideBadge?: boolean;
}
